module.exports = __webpack_public_path__ + "img/3_48.8a085fa6.png";